import { SegmentationReviewView } from './SegmentationReviewView'

export const SegmentationReview = () => {
  return <SegmentationReviewView />
}
